<template>
  <div class="p-d-flex p-flex-wrap p-ai-center" v-if="status">
    <div class="state-badge" :class="status.color || ''">
      {{ status.label?.[$i18n.locale] || status.label?.en || '' }}
    </div>
  </div>
  <i class="ti-minus" v-else/>
</template>

<script>
import SmsSenderStates from "@/translations/states/SmsSenderStates";

export default {
  name: 'SmsSenderStatus',
  props: {
    state: {
      type: Number,
      default: null
    },
  },
  computed: {
    status() {
      if (this.state == null) return null
      return SmsSenderStates.find(s => Number(s.id) === Number(this.state)) || null
    },
  },
}
</script>